import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookies_accepted");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookies_accepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-[#2A3A31] text-white rounded-2xl p-5 shadow-[0_-8px_30px_rgba(0,0,0,0.15)] flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm leading-relaxed flex-1" style={{ fontFamily: 'Manrope' }}>
          Ce site utilise uniquement des cookies essentiels pour le fonctionnement de l'application (authentification). Aucun cookie publicitaire ou de traçage.{' '}
          <Link to="/confidentialite" className="text-[#A8C5B4] hover:underline">En savoir plus</Link>
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={accept}
            className="px-5 py-2 bg-[#6B8576] hover:bg-[#5A7365] text-white rounded-full text-sm font-medium transition-all duration-300"
            data-testid="cookie-accept"
          >
            Compris
          </button>
          <button
            onClick={accept}
            className="p-1.5 hover:bg-white/10 rounded-full transition-colors duration-200"
            aria-label="Fermer"
          >
            <X className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
};
